export enum DossierSectionOptions {
  // sub sections for GeneralDeclaration
  GeneralDeclarationPortcallData = 'GeneralDeclaration.PortcallData',
  GeneralDeclarationVesselData = 'GeneralDeclaration.VesselData',
  GeneralDeclarationInspections = 'GeneralDeclaration.Inspections',
  GeneralDeclarationCargoInformation = 'GeneralDeclaration.CargoInformation',
  ArrivalDangerousGoodsDeclaration = 'ArrivalDangerousGoodsDeclaration',
  DepartureDangerousGoodsDeclaration = 'DepartureDangerousGoodsDeclaration',
  GeneralDeclarationDeclaration = 'GeneralDeclaration.Declaration',

  // sections
  GeneralDeclaration = 'GeneralDeclaration',
  SolasAndIsps = 'SolasAndIsps',
  ArrivalCrew = 'ArrivalCrew',
  DepartureCrew = 'DepartureCrew',
  ArrivalPassenger = 'ArrivalPassenger',
  DeparturePassenger = 'DeparturePassenger',
  MarpolWaste = 'MarpolWaste',
  HealthDeclaration = 'HealthDeclaration',
  LocalFormalities = 'LocalFormalities',
  ShipCertificates = 'ShipCertificates',
}

export enum DossierSectionStatusOptions {
  NotSubmittedToNMap = 'NotSubmittedToNMap',
  SubmittedToNmap = 'SubmittedToNmap',
  SubmittedToPA = 'SubmittedToPA',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export type SectionName = {
  sectionName: DossierSectionOptions[];
  sectionDisplayName: string;
};

export const SectionNameMapper: SectionName[] = [
  {
    sectionName: [DossierSectionOptions.GeneralDeclarationPortcallData],
    sectionDisplayName: 'Port call data',
  },
  {
    sectionName: [DossierSectionOptions.GeneralDeclarationVesselData],
    sectionDisplayName: 'Vessel Data',
  },
  {
    sectionName: [DossierSectionOptions.GeneralDeclarationInspections],
    sectionDisplayName: 'Inspections',
  },
  {
    sectionName: [DossierSectionOptions.GeneralDeclarationCargoInformation],
    sectionDisplayName: 'Cargo Information',
  },
  {
    sectionName: [
      DossierSectionOptions.ArrivalDangerousGoodsDeclaration,
      DossierSectionOptions.DepartureDangerousGoodsDeclaration,
    ],
    sectionDisplayName: 'Dangerous Goods',
  },
  {
    sectionName: [DossierSectionOptions.GeneralDeclarationDeclaration],
    sectionDisplayName: 'Declaration',
  },
  {
    sectionName: [DossierSectionOptions.GeneralDeclaration],
    sectionDisplayName: 'General Declaration',
  },
  {
    sectionName: [DossierSectionOptions.SolasAndIsps],
    sectionDisplayName: 'SOLAS and ISPS code',
  },
  {
    sectionName: [
      DossierSectionOptions.ArrivalCrew,
      DossierSectionOptions.DepartureCrew,
    ],
    sectionDisplayName: 'Crew',
  },
  {
    sectionName: [DossierSectionOptions.ArrivalCrew],
    sectionDisplayName: 'Arrival',
  },
  {
    sectionName: [DossierSectionOptions.DepartureCrew],
    sectionDisplayName: 'Departure',
  },
  {
    sectionName: [
      DossierSectionOptions.ArrivalPassenger,
      DossierSectionOptions.DeparturePassenger,
    ],
    sectionDisplayName: 'Passengers',
  },
  {
    sectionName: [DossierSectionOptions.ArrivalPassenger],
    sectionDisplayName: 'Arrival',
  },
  {
    sectionName: [DossierSectionOptions.DeparturePassenger],
    sectionDisplayName: 'Departure',
  },
  {
    sectionName: [DossierSectionOptions.MarpolWaste],
    sectionDisplayName: 'Marpol waste',
  },
  {
    sectionName: [DossierSectionOptions.HealthDeclaration],
    sectionDisplayName: 'Health Declaration',
  },
  {
    sectionName: [DossierSectionOptions.LocalFormalities],
    sectionDisplayName: 'Local Formalities',
  },
  {
    sectionName: [DossierSectionOptions.ShipCertificates],
    sectionDisplayName: 'Ship Certificates',
  },
];
